import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Partner } from '../../services/data.service';
import { PartnerService } from '../../services/partner.service';
import { RatingService } from '../../services/rating.service';
import { GclidService } from '../../services/gclid.service';
import { DeviceDetectService } from '../../services/device-detect.service';

@Component({
  selector: 'app-brand-list',
  templateUrl: './brand-list.component.html',
  styleUrls: ['./brand-list.component.scss']
})
export class BrandListComponent implements OnInit {
  partners$: Observable<Partner[]>;
  isMobile: boolean = false;
  imageErrors: Set<string> = new Set();

  constructor(
    private partnerService: PartnerService,
    private ratingService: RatingService,
    private gclidService: GclidService,
    private deviceDetectService: DeviceDetectService
  ) {
    this.partners$ = this.partnerService.getPartners();
  }

  ngOnInit(): void {
    this.isMobile = this.deviceDetectService.getIsMobile();
  }

  getRating(order: number): number {
    return this.ratingService.calculateRating(order);
  }

  getStars(order: number): number {
    return this.ratingService.calculateStars(order);
  }

  onPartnerClick(partner: Partner, event: Event): void {
    const urlWithGclid = this.gclidService.appendToUrl(partner.partnerUrl);
    window.open(urlWithGclid, '_blank', 'noopener,noreferrer');
    event.preventDefault();
  }

  getPartnerUrl(partner: Partner): string {
    return this.gclidService.appendToUrl(partner.partnerUrl);
  }

  getStarArray(count: number): number[] {
    return Array(Math.floor(count)).fill(0);
  }

  getEmptyStarArray(count: number): number[] {
    return Array(count).fill(0);
  }

  getEmptyStarCount(stars: number): number {
    return 5 - Math.ceil(stars);
  }

  hasHalfStar(stars: number): boolean {
    return stars % 1 !== 0;
  }

  onImageError(partnerId: string, event: Event): void {
    const img = event.target as HTMLImageElement;
    if (!this.imageErrors.has(partnerId)) {
      this.imageErrors.add(partnerId);
      // Hide the image instead of trying to load a placeholder
      img.style.display = 'none';
    }
  }

  hasImageError(partnerId: string): boolean {
    return this.imageErrors.has(partnerId);
  }

  trackByPartnerId(index: number, partner: Partner): string {
    return partner.id;
  }
}

